import {
	DELETE_FAQ_FAIL,
	DELETE_FAQ_START, DELETE_FAQ_SUCCESS,
	GENERATE_FAQ_FAIL,
	GENERATE_FAQ_START,
	GENERATE_FAQ_SUCCESS, SEARCH_FAQ_FAIL,
	SEARCH_FAQ_START,
	SEARCH_FAQ_SUCCESS, UPDATE_FAQ_FAIL, UPDATE_FAQ_START, UPDATE_FAQ_SUCCESS
} from "./actions/ActionTypes";

export const initFaqState = () => {
	return {
		loadingAddFaq: true,
		errorAddFaq: "",
		loadingSearchFaq: true,
		errorSearchFaq: "",
		faqs: [],
		loadingDeleteFaq: true,
		errorDeleteFaq: "",
		loadingUpdateFaq: true,
		errorUpdateFaq: "",
	}
}

export const FAQ_INITIAL_STATE = {}

export const FaqReducer = (state = FAQ_INITIAL_STATE, action) => {
	/*console.log(action)*/
	switch (action.type) {
		case GENERATE_FAQ_START:
			return {
				...state,
				loadingAddFaq: true,
				errorAddFaq: "",
			}
		case GENERATE_FAQ_SUCCESS:
			return {
				...state,
				loadingAddFaq: false,
				errorAddFaq: "",
			}
		case GENERATE_FAQ_FAIL:
			return {
				...state,
				loadingAddFaq: false,
				errorAddFaq: action.error,
			}
		case SEARCH_FAQ_START:
			return {
				...state,
				loadingSearchFaq: true,
				errorSearchFaq: "",
				loadingAddFaq: true
			}
		case SEARCH_FAQ_SUCCESS:
			return {
				...state,
				loadingSearchFaq: false,
				errorSearchFaq: "",
				faqs: action.payload,
			}
		case SEARCH_FAQ_FAIL:
			return {
				...state,
				loadingSearchFaq: false,
				errorSearchFaq: action.error,
				faqs: [],
			}
		case DELETE_FAQ_START:
			return {
				...state,
				loadingDeleteFaq: true,
				errorDeleteFaq: "",
			}
		case DELETE_FAQ_SUCCESS:
			return {
				...state,
				loadingDeleteFaq: false,
				errorDeleteFaq: "",
			}
		case DELETE_FAQ_FAIL:
			return {
				...state,
				loadingDeleteFaq: false,
				errorDeleteFaq: action.error,
			}
		case UPDATE_FAQ_START:
			return {
				...state,
				loadingUpdateFaq: true,
				errorUpdateFaq: "",
			}
		case UPDATE_FAQ_SUCCESS:
			return {
				...state,
				loadingUpdateFaq: false,
				errorUpdateFaq: "",
			}
		case UPDATE_FAQ_FAIL:
			return {
				...state,
				loadingUpdateFaq: false,
				errorUpdateFaq: action.error,
			}
		
		default:
			return state;
	}
}
